import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-black text-zinc-100 grid-bg flex flex-col">
      <div className="border-b border-zinc-900 bg-black/80 backdrop-blur px-6 py-3">
        <Logo size={28} />
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md border border-amber-500/40 bg-zinc-950 p-8 text-center space-y-4" data-testid="payment-cancel">
          <AlertCircle size={44} className="mx-auto text-amber-400" />
          <div className="font-display text-2xl">Payment cancelled</div>
          <div className="mono text-[11px] text-zinc-500">
            No charge was made. You can retry the upgrade from Super Admin at any time.
          </div>
          <Button
            data-testid="payment-cancel-back"
            onClick={() => navigate("/super")}
            className="rounded-none bg-cyan-500 hover:bg-cyan-400 text-black uppercase tracking-widest text-xs"
          >
            ▸ Back to Super Admin
          </Button>
        </div>
      </div>
    </div>
  );
}
